import { useContext, useMemo } from "react";
import { useBuilderStore } from "@/react/components/shared/BuilderUI/Hooks/useBuilderStore";
import { BlockEditorContext } from "@/react/components/shared/uikit/TipTapBlockEditor";
import { StaticTextRenderer } from "@circle-react-shared/BuilderUI/DefaultBlocks/Content/RichText/StaticTextRenderer";
import type { TipTapContent } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textTypes";
import { BuilderUIContext } from "@circle-react-shared/BuilderUI/Provider/BuilderUIProvider";
import { resolveVariableValuesFromStyleObject } from "../../Design/getVisualEmailBuilderStyleMap";
import { useSgidContext } from "./SgIdProvider";
import type { LinkStyles } from "./Utils/getLinkStyles";
import { VisualEmailTextRenderer } from "./VisualEmailTextRenderer";

interface TextRendererProps {
  blockPath: string;
  className?: string;
  isPreviewMode?: boolean;
  placeholder?: string;
  text: string | TipTapContent | undefined;
}

export const TextRenderer = (props: TextRendererProps) => {
  const builderContext = useContext(BuilderUIContext);
  const { localSgidToObjectMap, onLocalSgidToObjectMapChange } =
    useSgidContext();

  const currentCanvasTheme = useBuilderStore(state => state.currentCanvasTheme);

  // use theme text link color in Tiptap editor
  const linkStyles = useMemo((): LinkStyles => {
    const { color } = resolveVariableValuesFromStyleObject({
      styleObject: { color: "var(--theme-email-color-text-link)" },
      currentTheme: currentCanvasTheme,
    });

    return {
      color: color as string,
    };
  }, [currentCanvasTheme]);

  return builderContext ? (
    <BlockEditorContext.Provider
      value={{
        localSgidToObjectMap,
        addToLocalSgidToObjectMap: onLocalSgidToObjectMapChange,
      }}
    >
      <VisualEmailTextRenderer {...props} linkStyles={linkStyles} />
    </BlockEditorContext.Provider>
  ) : (
    <StaticTextRenderer {...props} />
  );
};
